var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#E3CDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2852_8269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7493 13.6834C21.241 13.6834 20.6243 12.6167 21.3743 11.3084C21.8077 10.55 21.5493 9.58336 20.791 9.15003L19.3493 8.32503C18.691 7.93336 17.841 8.1667 17.4493 8.82503L17.3577 8.98336C16.6077 10.2917 15.3743 10.2917 14.616 8.98336L14.5243 8.82503C14.1493 8.1667 13.2993 7.93336 12.641 8.32503L11.1993 9.15003C10.441 9.58336 10.1827 10.5584 10.616 11.3167C11.3743 12.6167 10.7577 13.6834 9.24935 13.6834C8.38268 13.6834 7.66602 14.3917 7.66602 15.2667V16.7334C7.66602 17.6 8.37435 18.3167 9.24935 18.3167C10.7577 18.3167 11.3743 19.3834 10.616 20.6917C10.1827 21.45 10.441 22.4167 11.1993 22.85L12.641 23.675C13.2993 24.0667 14.1493 23.8334 14.541 23.175L14.6327 23.0167C15.3827 21.7084 16.616 21.7084 17.3743 23.0167L17.466 23.175C17.8577 23.8334 18.7077 24.0667 19.366 23.675L20.8077 22.85C21.566 22.4167 21.8243 21.4417 21.391 20.6917C20.6327 19.3834 21.2493 18.3167 22.7577 18.3167C23.6243 18.3167 24.341 17.6084 24.341 16.7334V15.2667C24.3327 14.4 23.6243 13.6834 22.7493 13.6834ZM15.9993 18.7084C14.5077 18.7084 13.291 17.4917 13.291 16C13.291 14.5084 14.5077 13.2917 15.9993 13.2917C17.491 13.2917 18.7077 14.5084 18.7077 16C18.7077 17.4917 17.491 18.7084 15.9993 18.7084Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2852_8269)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e46957bf5183957ec706848ef3941f71.svg";
export { ForwardRef as ReactComponent };